<div class="static-page">
  <!-- Header -->
  <header class="page-header">
    <h1>{{ pageTitle }}</h1>
  </header>

  <!-- Content -->
  <main class="page-content">
    <ng-content></ng-content>
  </main>

  <!-- Footer -->
  <footer class="page-footer">
    <div class="footer-content">
      <!-- Our Company Section -->
      <div class="footer-section company-section">
        <h4>Our Company</h4>
        <div class="company-links">
          <a
            [href]="aboutCiraNetUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            About CiraNet
            <app-icon
              name="external-link"
              size="14px"
              ariaLabel="Opens in new tab"
            ></app-icon>
          </a>
          <a
            [href]="realManageUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            RealManage
            <app-icon
              name="external-link"
              size="14px"
              ariaLabel="Opens in new tab"
            ></app-icon>
          </a>
          <a
            [href]="residentPortalUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            Resident Portal
            <app-icon
              name="external-link"
              size="14px"
              ariaLabel="Opens in new tab"
            ></app-icon>
          </a>
          <a
            [href]="privacyPolicyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            Privacy Policy
            <app-icon
              name="external-link"
              size="14px"
              ariaLabel="Opens in new tab"
            ></app-icon>
          </a>
          <a
            [href]="termsAndConditionsUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            Terms and Conditions
            <app-icon
              name="external-link"
              size="14px"
              ariaLabel="Opens in new tab"
            ></app-icon>
          </a>
        </div>
      </div>

      <!-- Contact Row -->
      <div class="footer-section contact-section">
        <div class="contact-column">
          <h4>Customer Support</h4>
          <p>
            Email:
            <a [href]="'mailto:' + customerSupportEmail">
              {{ customerSupportEmail }}
            </a>
          </p>
        </div>
        <div class="contact-column">
          <h4>Contact Us</h4>
          <p>
            Phone:
            <a [href]="'tel:' + contactPhone">{{ contactPhone }}</a>
            <span class="address">Address: {{ contactAddress }}</span>
          </p>
        </div>
      </div>
    </div>
  </footer>

  <!-- Footer Bar -->
  <div class="footer-bar">
    <app-icon
      name="footer-logo"
      width="193px"
      height="40px"
      ariaLabel="footer logo"
    ></app-icon>
  </div>
</div>
